module.exports = __webpack_public_path__ + "img/login-img.28496e1d.png";